import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';

function LinearProgressWithLabel(props) {

  const checkValue = (value) => {
    if (value >= 0 && value <= 100) {
      return value;
    } else if (value > 100) {
      return 100;
    } else if (value < 0) {
      return 0;
    }
  };

  const renderRight = () => {
    if (props.length.length > 0) {
      return <Box className="muvika-linear-progress-bar-right">
        <Typography variant="body2" color="text.secondary">{props.length}</Typography>
      </Box>;
    }
  };

  return (
    <Box className="muvika-linear-progress-bar">
      <Box>
        <Typography variant="body2" color="text.secondary">{props.currentTime}</Typography>
      </Box>
      <Box className="muvika-linear-progress-bar-left">
        <LinearProgress sx={{ height: "0.56rem", marginTop: "-0.05rem" }} onClick={props.onProgressClick} variant="buffer" value={checkValue(props.value)} valueBuffer={checkValue(props.buffer)} />
      </Box>
      {renderRight()}
    </Box>
  );
}

export default LinearProgressWithLabel;